export default __webpack_public_path__ + "static/media/featSportBg.eb41448d.png";